import useSWR from 'swr';
import api from '../utils/api';

/**
 * Custom hooks for data fetching with SWR
 * Provides automatic caching, revalidation, and loading states
 */

const fetcher = (url) => api.get(url).then(res => res.data);

// Roles
export const useRoles = () => {
  const { data, error, mutate } = useSWR('/roles', fetcher, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true
  });
  
  return {
    roles: data || [],
    isLoading: !error && !data,
    isError: error,
    refresh: mutate
  };
};

// TeamMembers/Team
export const useTeamMembers = () => {
  const { data, error, mutate } = useSWR('/team', fetcher, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true
  });
  
  return {
    team_members: data || [],
    isLoading: !error && !data,
    isError: error,
    refresh: mutate
  };
};

// Assets/Assets
export const useAssets = () => {
  const { data, error, mutate } = useSWR('/assets', fetcher, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true
  });
  
  return {
    assets: data || [],
    isLoading: !error && !data,
    isError: error,
    refresh: mutate
  };
};

// Services
export const useServices = () => {
  const { data, error, mutate } = useSWR('/services', fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: true
  });
  
  return {
    services: data || [],
    isLoading: !error && !data,
    isError: error,
    refresh: mutate
  };
};

// Schedule Bookings (calendar/schedule view)
export const useScheduleBookings = () => {
  const { data, error, mutate } = useSWR('/bookings', fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: true
  });
  
  return {
    bookings: data || [],
    isLoading: !error && !data,
    isError: error,
    refresh: mutate
  };
};

// Customer Bookings (from widget)
export const useBookings = () => {
  const { data, error, mutate } = useSWR('/bookings', fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: true
  });
  
  return {
    bookings: data || [],
    isLoading: !error && !data,
    isError: error,
    refresh: mutate
  };
};
